export default __webpack_public_path__ + "static/skillsAnimationMobile-902e1f28d5b66413d8f193394b99a9fa.mp4";